import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { MsalProvider } from "@azure/msal-react";
import { EventType } from "@azure/msal-browser";
import { msalInstance, msalReady } from "./auth/msalInstance";
import { BranchProvider } from "./auth/BranchContext";

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});

msalReady
  .then(() => msalInstance.handleRedirectPromise())
  .then((resp) => {
    if (resp?.account) msalInstance.setActiveAccount(resp.account);

    const accounts = msalInstance.getAllAccounts();
    if (!msalInstance.getActiveAccount() && accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }

    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(
      //<React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <BranchProvider>
            <App />
          </BranchProvider>
        </MsalProvider>
     // </React.StrictMode>
    );
  })
  .catch((e) => {
    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(
     // <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <BranchProvider>
            <App />
          </BranchProvider>
        </MsalProvider>
     // </React.StrictMode>
    );
    console.error(e);
  });

reportWebVitals();